import { render, staticRenderFns } from "./TitleDesc.vue?vue&type=template&id=429b416d&"
import script from "./TitleDesc.vue?vue&type=script&lang=js&"
export * from "./TitleDesc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\laragon\\www\\webinane\\wp-content\\plugins\\lifeline-donation-pro\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('429b416d')) {
      api.createRecord('429b416d', component.options)
    } else {
      api.reload('429b416d', component.options)
    }
    module.hot.accept("./TitleDesc.vue?vue&type=template&id=429b416d&", function () {
      api.rerender('429b416d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/TitleDesc.vue"
export default component.exports